import React, { FC } from 'react';

import {
	AlertTriangle,
	BUTTON_TYPES,
	Download,
	EvBodyMedium,
	EvBodyMediumBold,
	EvButton,
	EvFlexColumn,
	EvFlexRow,
	EvIconButton,
	EvSection,
	EvSvgIcon,
	TEXT_COLOR,
	X
} from '@evinced-private/ui-common';

import { CSV_UPLOAD_ERROR_BANNER_LABELS } from './CsvUploadErrorBanner.labels';
import { CsvUploadErrorBannerProps } from './CsvUploadErrorBanner.types';

import './CsvUploadErrorBanner.scss';

export const CsvUploadErrorBanner: FC<CsvUploadErrorBannerProps> = ({
	onDownload,
	onDismiss,
	dataAutomationId,
	downloadDataAutomationId,
	dismissDataAutomationId
}) => {
	return (
		<EvSection
			ariaLabel={CSV_UPLOAD_ERROR_BANNER_LABELS.SECTION_ARIA}
			ariaLive="assertive"
			dataAutomationId={dataAutomationId}
		>
			<EvFlexColumn gap="LARGE" padding="LARGE">
				<EvFlexRow justify="SPACE_BETWEEN" align="CENTER">
					<EvFlexRow gap="SMALL" align="CENTER" justify="START">
						<EvSvgIcon icon={AlertTriangle} isSmall />
						<EvBodyMediumBold color={TEXT_COLOR.CONTENT_2}>
							{CSV_UPLOAD_ERROR_BANNER_LABELS.TITLE}
						</EvBodyMediumBold>
					</EvFlexRow>
					{onDismiss && (
						<EvIconButton
							icon={X}
							ariaLabel={CSV_UPLOAD_ERROR_BANNER_LABELS.DISMISS_ARIA}
							onClick={onDismiss}
							dataAutomationId={dismissDataAutomationId}
						/>
					)}
				</EvFlexRow>
				<EvBodyMedium color={TEXT_COLOR.CONTENT_3}>
					{CSV_UPLOAD_ERROR_BANNER_LABELS.BODY}
				</EvBodyMedium>
				<EvFlexRow justify="END">
					<EvButton
						type={BUTTON_TYPES.PRIMARY}
						title={CSV_UPLOAD_ERROR_BANNER_LABELS.DOWNLOAD_BUTTON}
						onClick={onDownload}
						dataAutomationId={downloadDataAutomationId}
					>
						<EvFlexRow wrap="NOWRAP" justify="START">
							{CSV_UPLOAD_ERROR_BANNER_LABELS.DOWNLOAD_BUTTON}
							<EvSvgIcon icon={Download} isSmall />
						</EvFlexRow>
					</EvButton>
				</EvFlexRow>
			</EvFlexColumn>
		</EvSection>
	);
};
